import CurrencyExchangeList from './List'

export default {
  list: CurrencyExchangeList
}
